export enum Alignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export const ALL_VC_TYPE_NAME = '__all__';
